import { translationNavigation_sv_part1 } from "./translationNavigation.sv.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationNavigation_sv_part2 } from "./translationNavigation.sv.part2";
import { translationNavigation_sv_part3 } from "./translationNavigation.sv.part3";

export const translationNavigation_sv = defineTranslationTree({
  ...translationNavigation_sv_part1,
  ...translationNavigation_sv_part2,
  ...translationNavigation_sv_part3,
});
